<template>
    <section class="content-item flexContainer full" v-if="Object.keys(item).length > 0">
        <div class="item flexContainer full ai-c xs-fd-c">
            <div class="flexContainer size7of12 xs-w-full">
                <figure class="jc-c ac-fs ai-fs size3of12 txtCenter m-w-mid xs-w-one-quart">
                    <SystemTypeIcon :type="item.systemType && item.systemType.id"></SystemTypeIcon>
                </figure>

                <div class="flexContainer size5of12 fd-c m-w-mid xs-w-three-quart">
                    <span class="list-item-name uppercase" v-if="item.name !== ''">{{ item.name }}</span>
                    <span class="list-item-name uppercase" v-else>no name</span> <span class="list-item-size">{{ item.size }}</span>
                    <span class="list-item-info uppercase">{{ item.brand.name }}</span>
                    <span class="list-item-info uppercase" v-if="item.standDesign !== null">{{ item.standDesign.name }}</span>
                </div>

                <div class="flexContainer size4of12 fd-c mobileNot">
                    <span class="ff-light">
                        <span class="ff-bold">{{ $t("planoList.created") }}:</span> {{ item.user.dateCreated }}
                    </span>
                    <span class="ff-light">
                        <span class="ff-bold">{{ $t("planoList.by") }}</span> {{ item.user.firstname }} {{ item.user.lastname }}
                    </span>
                    <span class="ff-light"> <span class="ff-bold">Visibility</span> {{ item.visiblility }} ({{ item.id }}) </span>
                </div>
            </div>
            <div class="flexContainer size3of12 xs-mt10">
                <span class="list-item-status uppercase txtCenter" :class="item.status">{{ item.status }}</span>
            </div>
            <div class="size2of12" v-if="item.actions">
                <button v-for="(action, i) in item.actions" :key="i" class="btn editBtn center uppercase" @click="actionEvent(action);">
                    {{ $t("displayer." + action.label) }}
                </button>
            </div>
        </div>
    </section>
</template>
<script>
import SystemTypeIcon from "@/components/planoList/SystemTypeIcon";

export default {
    props: { item: Object },
    components: { SystemTypeIcon },
    methods: {
        actionEvent(action) {
            action.action.apply(null, action.args);
        }
    }
};
</script>
<style lang="scss">
@import "../../../assets/css/themes.scss";

.editBtn {
    margin-right: 10px;
}
.content-item {
    @extend %second-bloc;
    @extend %second-text;
    font-size: 14px;
    margin-bottom: 20px;
    padding: 15px;

    .list-item-status {
        display: inline-block;
        margin: auto;
        color: #fff;
        padding: 5px;
        height: 25px;
    }

    .active {
        background-color: #a3d300;
    }

    .inactive {
        background-color: #ff7a14;
    }
    .content-info {
        margin-top: 10px;
    }
    .list-item-img {
        margin: 10px;
    }
    .list-item-name {
        font-family: "Oswald", Sans-Serif;
        margin: 2px;
        padding: 0px;
        font-size: 25px;
        font-weight: bold;
    }
    .list-item-size {
        font-size: 14px;
    }

    .list-item-info {
        font-weight: bold;
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// Item.vue?83fa7aaa